import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { EDITOR, COMMENTER, VIEWER, NO_ACCESS } from '../../../constants'
import { withTranslation } from 'react-i18next'
import Select from 'common/components/Select'
import { connect } from 'formik';

const levels = [
  EDITOR,
  COMMENTER,
  VIEWER
]

export class AccessSelect extends Component {
  render() {
    const { formik, remove, onChange, inherited, t, ...props } = this.props
    const { values, handleChange } = formik
    const handleChange2 = e => {
      handleChange(e)
      onChange && setTimeout(onChange, 4)
    }
    const level = values['shareLevel']
    return (
      <Select
        name="shareLevel"
        onChange={handleChange2}
        value={level}
        {...props}
      >
        {levels.map(level => (
          <option
            value={level}
            disabled={inherited && inherited > level}
            key={level}
          >
            {t('share.canAccess', { level: t(`accessLevel.${level}`) })}
            {inherited && inherited === level && ' ' + t('share.inherited')}
          </option>
        ))}
        {remove && <option disabled>——————</option>}
        {remove && (
          <option disabled={!!inherited} value={NO_ACCESS}>
            {remove}
          </option>
        )}
      </Select>
    )
  }

  static propTypes = {
    remove: PropTypes.string,
    onChange: PropTypes.func
  }
}

export default withTranslation()(connect(AccessSelect))
